import { NgModule } from '@angular/core';
import { PrettydatePipe } from './prettydate/prettydate';
@NgModule({
	declarations: [PrettydatePipe],
	imports: [],
	exports: [PrettydatePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts